export var buildEnv = {
    buildMode: 'release',
    datacenter: 'us',
    sdkEnv: 'production',
    sdkVersion: '1.12.3',
};
//# sourceMappingURL=buildEnv.js.map